import { cn } from "@au-schein-de/au-ui-library";
import { Fragment, type ReactNode } from "react";

function escapeRegExp(value: string): string {
	return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

/**
 * Renders `text` with every case-insensitive occurrence of `query` wrapped in a
 * bold span. Returns the text unchanged when `query` is empty/absent, so it is a
 * no-op when nothing is being searched.
 */
export function HighlightMatch({
	text,
	query,
	className,
}: {
	text: string;
	query?: string;
	className?: string;
}): ReactNode {
	const trimmed = query?.trim() ?? "";
	if (!trimmed) return text;
	// Capture-group split => odd indices are the matched segments.
	const parts = text.split(new RegExp(`(${escapeRegExp(trimmed)})`, "ig"));
	let offset = 0;
	return parts.map((part, index) => {
		const key = `${offset}-${part}`;
		offset += part.length;
		if (!part) return null;
		// <strong> is already bold via the preflight reset; only darken it.
		return index % 2 === 1 ? (
			<strong key={key} className={cn("text-gray-700", className)}>
				{part}
			</strong>
		) : (
			<Fragment key={key}>{part}</Fragment>
		);
	});
}
